export default __webpack_public_path__ + "static/media/52.f44506c1.jpg";